import React from 'react';
import { Switch } from 'react-router-dom';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';

import DispatchCenter from './dispatch-center';
import DispatchCenterDetail from './dispatch-center-detail';
import DispatchCenterUpdate from './dispatch-center-update';
import DispatchCenterDeleteDialog from './dispatch-center-delete-dialog';

const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute exact path={`${match.url}/new`} component={DispatchCenterUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id/edit`} component={DispatchCenterUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id`} component={DispatchCenterDetail} />
      <ErrorBoundaryRoute path={match.url} component={DispatchCenter} />
    </Switch>
    <ErrorBoundaryRoute exact path={`${match.url}/:id/delete`} component={DispatchCenterDeleteDialog} />
  </>
);

export default Routes;
